export default __webpack_public_path__ + "static/media/Inter-ExtraLightItalic.cca8e7e8.woff2";